// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__29Dtb","vtpLogo":"Footer_vtpLogo__2K2LK"};